export default "__VITE_ASSET__BYG2Bt_H__"